import { render, staticRenderFns } from "./KitsListaItem.vue?vue&type=template&id=fe3ed12e&"
import script from "./KitsListaItem.vue?vue&type=script&lang=js&"
export * from "./KitsListaItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports